import { BusinessAutomationActionTypeEnum } from '@reach/shared-types/business-automation';
import { Mail } from 'lucide-react';
import React, { useContext, useState } from 'react';
import { AutomationEditorContext } from '../AutomationEditorContext';
import { Step } from '../Step';
import { SendMessageDialog } from './SendMessageDialog';

interface SendMessageStepProps {
  index: number;
}

export const SendMessageStep: React.FC<SendMessageStepProps> = ({ index }) => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { state } = editor;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const action = state.localContents.actionData?.[index];
  if (!action || action.type !== BusinessAutomationActionTypeEnum.SEND_COMMUNICATION) {
    return null;
  }

  const { subject, text, html } = action;
  const hasContent = !!(subject || text || html);
  const configuredDisplayText = subject || 'Message configured';
  const unconfiguredDisplayText = 'Click Configure to write your email';
  const subtitle = hasContent ? configuredDisplayText : unconfiguredDisplayText;

  return (
    <>
      <Step
        index={index}
        icon={Mail}
        title="Send Message"
        subtitle={subtitle}
        needsSetup={!hasContent}
        onConfigure={() => setIsDialogOpen(true)}
      />
      {isDialogOpen && (
        <SendMessageDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          action={action}
          actionIndex={index}
        />
      )}
    </>
  );
};
